import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgRsStampComplete = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183 183"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsxs("g", {
        opacity: 0.2,
        transform: "translate(5.693 10.573)",
        children: [/*#__PURE__*/jsx("circle", {
          cx: 80.687,
          cy: 80.687,
          r: 80.687,
          fillRule: "nonzero",
          opacity: 0.2,
          transform: "translate(4.923)"
        }), /*#__PURE__*/jsx("circle", {
          cx: 85.61,
          cy: 80.687,
          r: 80.687
        })]
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "M26.951 117.431c.433 6.25-4.082 10.332-9.383 11.85-7.49 2.145-11.291-1.7-11.79-8.893-.698-7.009 2.936-12.917 10.16-14.986 5.386-1.543 10.107-.524 10.602 6.125l-7.757 2.223c-.298-2.541-1.222-2.79-2.256-2.494-2.191.628-2.232 3.074-1.979 6.717.24 3.456.596 5.98 2.729 5.37 1.095-.315 1.786-1.216 1.739-3.637l7.935-2.272zM38.438 98.96c7.373-2.112 11.382 1.705 11.872 8.773s-2.841 12.985-10.212 15.097c-7.372 2.111-11.381-1.706-11.873-8.773-.493-7.068 2.841-12.985 10.211-15.097zm1.25 17.963c1.303-.373 2.224-1.439 1.86-6.683-.356-5.12-1.337-5.767-2.699-5.378-1.362.388-2.215 1.563-1.859 6.683.366 5.245 1.396 5.75 2.7 5.378h-.003zm33.613-20.741-.059.015-1.892 17.072-7.757 2.22-4.147-15.341-.058.016 1.127 16.206-7.165 2.05-1.576-22.677 11.752-3.365 3.277 12.836.059-.016 1.398-14.175 11.752-3.366 1.576 22.678-7.164 2.05-1.127-16.206zm9.732-9.387 12.435-3.562c5.152-1.475 7.8 1 8.097 5.274.314 4.522-2.254 8.397-8.235 10.11l-2.783.797.531 7.632-8.468 2.426-1.576-22.677zm9.57 7.35c2.192-.629 2.962-1.713 2.849-3.314-.11-1.602-.87-2.09-2.706-1.563l-.888.255.33 4.743.416-.12v-.002zm12.34-13.625 8.468-2.426 1.154 16.583 7.786-2.229.424 6.094-16.253 4.655-1.577-22.677zm18.058-5.172 16.254-4.656.41 5.905-8.14 2.33.168 2.417 7.519-2.152.41 5.904-7.518 2.153.176 2.543 8.407-2.408.41 5.904-16.52 4.732-1.576-22.677zm22.924-.351-5.27 1.51-.425-6.092 19.007-5.444.425 6.092-5.27 1.509 1.155 16.583-8.468 2.426zm14.911-10.484 16.254-4.656.411 5.905-8.14 2.33.167 2.417 7.519-2.152.411 5.904-7.52 2.153.177 2.543 8.407-2.408.411 5.904-16.52 4.732-1.577-22.677zm-77.789 7.896a3.56 3.56 0 0 1-2.166-.734l-11.822-9.064 4.33-5.647 7.354 5.64 3.92-18.352 6.958 1.486-5.093 23.859a3.56 3.56 0 0 1-3.48 2.814z"
      }), /*#__PURE__*/jsx("path", {
        fill: "none",
        d: "M132.96 137.559c9.45-8.511 16.007-19.604 18.918-31.798l-105.09 29.071a62.36 62.36 0 0 0 44.506 18.716 62.17 62.17 0 0 0 41.668-15.987z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "M47.247 47.216C59.013 35.45 74.654 28.972 91.293 28.972a62.26 62.26 0 0 1 50.594 25.95l4.85-1.341c-12.516-18.384-33.224-29.352-55.444-29.352-17.905 0-34.739 6.973-47.399 19.632-11.754 11.755-18.6 27.105-19.522 43.568l4.847-1.341c1.2-14.689 7.492-28.338 18.03-38.875v.003zm85.713 90.343a62.16 62.16 0 0 1-41.668 15.986 62.36 62.36 0 0 1-44.506-18.715l-5.167 1.43c12.698 14.006 30.758 22.029 49.67 22.029 16.595 0 32.52-6.11 44.842-17.207 10.819-9.744 18.117-22.634 20.91-36.751l-5.165 1.43c-2.911 12.192-9.468 23.287-18.919 31.798z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgRsStampComplete$1 = SvgRsStampComplete;

export { SvgRsStampComplete$1 as default };
